import $ from 'jquery'
import 'jquery-validation'
import 'jquery-validation/dist/localization/messages_pl'
import IMask from "imask";

export default class ContactSendEmail {

	gRecaptchaResponseInput = '#g-recaptcha-response';

	constructor() {
		if (!document.querySelector('#contact-form')) return false

		const phoneInput = document.querySelector('.phone-mask')

		const mask = IMask(phoneInput, {
			mask: '000 000 000',
			lazy: false
		})

		$('#contact-form').validate({
			submitHandler:  (form) => {
				this.setRecaptcha()
					.then(() => {
						$('.contact-form-button').prop('disabled', true)
						$('.contact-form-button span').addClass('d-none')
						$('.contact-form-button i').removeClass('d-none')
						$('.contact-form-info').hide();
						const $form = $(form);
						const url = $form.attr('action');

						$.post( url, $form.serialize(), ( o ) => {
								if (o.send == true) {
									$( '.contact-form-info--ok' ).show();

									form.reset()
								} else {
									$( '.contact-form-info--error' ).show();
								}
								$( '.contact-form-button' ).prop( 'disabled', false )
								$( '.contact-form-button span' ).removeClass( 'd-none' )
								$( '.contact-form-button i' ).addClass( 'd-none' )
							}, 'json'
						);
					})

			},
			errorPlacement: (error, element) => {
					error.appendTo(element.closest('div'));
			}
		});
		/*$('#contact-form').on('submit', (e) => {
			e.preventDefault();
			const form = $(e.target);
			const url = form.attr('action');

			$.post(url, form.serialize(), (o) => {
					console.log(o);
				}, 'json'
			)
		})*/
	}

	setRecaptcha() {
		return new Promise(resolve => {
			grecaptcha.ready( () => {
				grecaptcha.execute( '6LdyxA4pAAAAABuxn188d6BaFLROrI8KFB9KQb2R', { action: 'submit' } ).then(  ( token ) => {
					$(this.gRecaptchaResponseInput).val(token);
					resolve(true);
				} );
			} );
		})
	}
}

